import { IconDefinition } from "./types";

const link: IconDefinition = {
  iconName: "link",
  width: 576,
  height: 512,
  svgPathData:
    "M427.5 88c-21.4 0-42.2 6.9-59.3 19.4-11.4-11.7-24.4-22.1-38.4-30.7 27-23.6 61.7-36.7 97.7-36.7 82 0 148.5 66.5 148.5 148.5 0 39.4-15.6 77.1-43.5 105l-79.1 79.1c-27.8 27.8-65.6 43.5-105 43.5-82 0-148.5-66.5-148.5-148.5 0-27.6 7.7-54.5 21.9-77.6L262.8 215c-9.6 15.7-14.8 33.8-14.8 52.5 0 55.5 45 100.5 100.5 100.5 26.6 0 52.2-10.6 71-29.4l79.1-79.1C517.4 240.6 528 215.1 528 188.5 528 133 483 88 427.5 88zm-200 56c-26.6 0-52.2 10.6-71 29.4L77.4 252.5c-18.8 18.8-29.4 44.4-29.4 71 0 55.5 45 100.5 100.5 100.5 21.4 0 42.2-6.9 59.3-19.4 11.4 11.8 24.4 22.1 38.4 30.7-27 23.6-61.7 36.7-97.7 36.7-82 0-148.5-66.5-148.5-148.5 0-39.4 15.6-77.1 43.5-105l79.1-79.1c27.8-27.8 65.6-43.5 105-43.5 82 0 148.5 66.5 148.5 148.5 0 27.6-7.7 54.5-21.9 77.6L313.2 297c9.6-15.7 14.8-33.8 14.8-52.5 0-55.5-45-100.5-100.5-100.5z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "link",
  unicode: 0xf0c1,
};

export { link };
